import { CustomFilterType } from './CustomFilter';
import {
    EnumValue, DateTimeRangeValue, StringValue, NumberValue, BooleanValue,
} from './Values';

interface SelectedItemEnum {
    value: EnumValue;
    type: CustomFilterType.enum;
}

interface SelectedItemDateTimeRange {
    value: DateTimeRangeValue;
    type: CustomFilterType.dateTimeRange;
}

interface SelectedItemString {
    value: StringValue;
    type: CustomFilterType.string;
}

interface SelectedItemNumber {
    value: NumberValue;
    type: CustomFilterType.number;
}

interface SelectedItemBoolean {
    value: BooleanValue;
    type: CustomFilterType.boolean;
}

export type SelectedItemItem =
    | SelectedItemEnum
    | SelectedItemDateTimeRange
    | SelectedItemString
    | SelectedItemNumber
    | SelectedItemBoolean

export enum SelectedItemType {
    predefinedView = 'predefinedView',
    customFilter = 'customFilter',
}

export interface SelectedItemPredefinedView {
    type: SelectedItemType.predefinedView;
    groupKey?: string;
    item: {
        value: string;
    };
}

export interface SelectedItemCustomFilter {
    type: SelectedItemType.customFilter;
    uniqueKey: string;
    item: SelectedItemItem;
}

export type SelectedItem =
    | SelectedItemPredefinedView
    | SelectedItemCustomFilter

export interface CustomFilterSelectedItem {
    name: string;
    item: SelectedItemItem;
}
